import dayjs from "dayjs";

import { MeCommittedDatabaseQuery } from "~/lib/graphql/client";

function buildLatestRespondedForms(
  responses: MeCommittedDatabaseQuery["me"]["responses"]
) {
  return [...responses]
    .sort((a, b) => dayjs(b.createdAt).unix() - dayjs(a.createdAt).unix())
    .map((response) => {
      const form = response.form;
      return {
        id: form.id,
        title: form.title,
        createdAt: response.createdAt,
        category: form.categories[0].name,
      };
    })
    .reduce(
      (forms, form) => {
        const formIndex = forms.findIndex((f) => f.id === form.id);
        if (formIndex === -1) {
          return [...forms, form];
        } else {
          return forms;
        }
      },
      [] as { id: number; title: string; createdAt: string; category: string }[]
    );
}

export { buildLatestRespondedForms };
